// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"37":"4eeb50cf","739":"4eeb50cf","848":"cc61ff01"}[chunkId] + ".css";
};